import angular from 'angular';
import template from './self-screen-frame-mini.html';
class SelfScreenFrameMiniController {
    constructor($element, VideoProviderFactory, $scope, $ngRedux) {
        this.$element = $element;
        this.VideoProviderFactory = VideoProviderFactory;
        this.$scope = $scope;
        this.$ngRedux = $ngRedux;
        this.MOBILE_AUTOHIDE_NPI_INFO_DELAY = 5000;
        this.stats = {};
        this.showNetworkScore = false;
        this.unsubscribeFromStore = this.$ngRedux.connect(this.mapStateToThis)(this);
        VideoProviderFactory.decorateScope(this);
    }
    $onInit() {
        this.$scope.$watch('$ctrl.withVideo', () => {
            if (this.withVideo) {
                this.$element[0]
                    .getElementsByClassName('call-frames__append-video')[0]
                    .appendChild(document.getElementById(this.videoPublisherId));
            }
        });
    }
    hasVideo() {
        const screenPublisher = this.activeVideoProvider.getScreensharePublisher();
        if (!screenPublisher || !screenPublisher.stream)
            return false;
        return screenPublisher.stream.hasVideo;
    }
    hasAudio() {
        const screenPublisher = this.activeVideoProvider.getScreensharePublisher();
        if (!screenPublisher || !screenPublisher.stream)
            return false;
        return screenPublisher.stream.hasAudio;
    }
    toggleAudio($event, toggler) {
        const screenPublisher = this.activeVideoProvider.getScreensharePublisher();
        if (!screenPublisher || !screenPublisher.stream)
            return false;
        screenPublisher.publishAudio(toggler);
        $event.stopPropagation();
    }
    mapStateToThis(state) {
        return {};
    }
    $onDestroy() {
        this.unsubscribeFromStore();
    }
}
const selfScreenFrameMiniComponent = {
    template,
    bindings: {
        withVideo: '<',
        videoPublisherId: '<',
        isInGroupCall: '<',
        isGalleryView: '<',
        onSelect: '&',
        isPinned: '<',
        isInCall: '<',
        avatarPicture: '<',
    },
    controller: SelfScreenFrameMiniController,
};
export default angular
    .module('doxy.videoChat.callFrames.selfScreenFrameMiniComponent', [])
    .component('selfScreenFrameMini', selfScreenFrameMiniComponent).name;
